export function toQueryParams(input: object): string {
  const params = new URLSearchParams();
  Object.entries(input).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    if (Array.isArray(value)) {
      if (value.length > 0) params.append(key, value.join(","));
    } else {
      params.append(key, String(value));
    }
  });
  return params.toString();
}
